import { useMemo } from "react"
import { InputText } from "src/shared/components/forms/input-text/InputText"
import { InputTextProps } from "src/shared/components/forms/input-text/input-text.props"
import "./Autocomplete.css"

interface AutocompleteProps extends Omit<InputTextProps, "onChange"> {
    value: string
    suggestion: string
    onChange: (value: string, fetch?: boolean) => void
}

export function Autocomplete({ value, suggestion, onChange, type = "text", ...rest }: AutocompleteProps) {
    const ghostText = useMemo(() => {
        if (!value) return ""
        if (!suggestion.toLowerCase()?.includes(value.toLowerCase())) return ""
        return value + suggestion.slice(value.length)
    }, [value, suggestion])

    return (
        <div className={"autocomplete__wrapper"}>
            {ghostText && ghostText !== value ? <div className={"autocomplete__ghost-text"}>{ghostText}</div> : null}
            <InputText
                type={"text"}
                value={value}
                onChange={(e) => onChange(e.target.value, true)}
                spellCheck={false}
                autoComplete="off"
                onKeyDown={(e) => {
                    if (e.key === "Enter" && suggestion) {
                        e.preventDefault()
                        onChange(suggestion)
                    }
                }}
                {...rest}
            />
        </div>
    )
}
